import { Flex, Text } from "@radix-ui/themes";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";

const CameraSkuSectionsNotFound = () => {
  return (
    <Flex
      justify="center"
      align="center"
      className="absolute inset-0 bg-black/30"
    >
      <Flex
        align="center"
        justify="center"
        gap="2"
        className="bg-red-600 px-4 py-2 rounded"
      >
        <ExclamationTriangleIcon className="text-white h-4 w-4" />
        <Text className="text-white" highContrast size="3">
          No camera sku sections found
        </Text>
      </Flex>
    </Flex>
  );
};

export default CameraSkuSectionsNotFound;
